import React, {useCallback, useEffect, useState} from 'react';
import {GlobalButtonFinal, ModalsWrapper, ModalWindow} from "../GlobalStyles";
import {useRouter} from "next/router";
import messages from '../../../../src/messages';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera } from '@fortawesome/pro-regular-svg-icons';


export default function DialogConfirmRender ({ renderPackshot, qualityRender, toggleConfirmRender,toggleConfirmRenderClose, creditAmount, renderTime}) {

    const [confirmRenderShow, setConfirmRenderShow] = useState(false);
    const [confirmRenderTransitionShow, setConfirmRenderTransitionShow] = useState(false);
    const router = useRouter();
    const changeConfirmRenderShow = (variable) => {

        if(variable === true){

            setConfirmRenderShow(variable);
            setTimeout(function() {
                setConfirmRenderTransitionShow(true);
            },1);




        } else{

            setConfirmRenderShow(false);
            setConfirmRenderTransitionShow(false);
            setTimeout(function() {
                setConfirmRenderShow(variable);
            },500);



        }

    };

    const toggleConfirmRenderInside = useCallback((): void => {
console.log("TOGGLE", confirmRenderShow);
        if(confirmRenderShow){
            changeConfirmRenderShow(false);
        }else{
            changeConfirmRenderShow(true);
        }


    }, []);
    useEffect(() => {

        toggleConfirmRender && toggleConfirmRender(toggleConfirmRenderInside);
    }, [toggleConfirmRender, toggleConfirmRenderInside]);




    const toggleConfirmRenderInsideClose = useCallback((): void => {
        setLoadingPackshot(false);
        changeConfirmRenderShow(false);

    }, []);
    useEffect(() => {

        toggleConfirmRenderClose && toggleConfirmRenderClose(toggleConfirmRenderInsideClose);
    }, [toggleConfirmRenderClose, toggleConfirmRenderInsideClose]);

    const closeModalOutsideClick = (e) => {

        // if( e.target.getAttribute("data-closemodal") === "true"){
        //     changeConfirmRenderShow(false);
        // }
    }
    const goToHomepage = () => {

     router.push("/");
    }

    const [loadingPackshot, setLoadingPackshot] = useState(false);


    const renderPackshotAndClose = () => {
       // setLoadingPackshot(true);
        changeConfirmRenderShow(false);
        renderPackshot(qualityRender);

    }

    return (
        <>
            <ModalsWrapper className={`confirmRenderCheck  ${confirmRenderTransitionShow ? 'showTransition' : 'hideTransition'}
             ${!confirmRenderShow ? 'hiddeComplete' : ''}`}
                           data-closemodal={true}
                           onClick={(e)=> closeModalOutsideClick(e)}
            >


                <ModalWindow
                    className={"center confirmRender"}
                    id={'confirmRenderProductDialog'}>
                    <div className={'modal-header'}>



                            <h4><FormattedMessage {...messages.modal_confirm_render_title}></FormattedMessage></h4>

   

                    </div>


                    <div className={'modal-content shareProduct'} style={{ display: "block" }}>
                        {!loadingPackshot ?
                        <span style={{
                            width: '100%',
                            fontSize: '15px',
                            color: 'var(--black-60, #666)',
                        } }>

                             <FormattedMessage {...messages.modal_confirm_render_description}
                                               values={{
                                                   creditAmount: `${creditAmount}`,
                                                   renderTime: `${renderTime}`,

                                               }}>
                                                                        {(msg) => (
                                                                            <>{msg}</>
                                                                        )}
                             </FormattedMessage>

                        </span> : null}

                        {!loadingPackshot ?
                            <div className={'modal-buttons'} style={{ width: '100%', height: 'auto' }}>


                                <GlobalButtonFinal style={{ width: 'fit-content' }} className={'borderBlue btn-circle'}
                                                   onClick={() => changeConfirmRenderShow(false)}>
                                    <FormattedMessage {...messages.modal_render_buttons_cancel}></FormattedMessage>
                                </GlobalButtonFinal>

                                <GlobalButtonFinal style={{ width: 'fit-content', marginLeft: '15px' }}
                                                   className={'backgroundBlue btn-circle'}
                                                   onClick={() => renderPackshotAndClose()}>
                                    <FontAwesomeIcon icon={faCamera}
                                                     style={{ marginRight: '5px' }} />
                                    <FormattedMessage {...messages.modal_render_buttons_create_packshot}></FormattedMessage>
                                </GlobalButtonFinal>

                            </div>
                            : <img src={'/logoAnimate.svg'} style={{     marginTop: "15px",  width: "60px",  paddingBottom: "15px"}} />
                        }


                    </div>
                </ModalWindow>


            </ModalsWrapper>


        </>
    )
}